import React from 'react';
import PropTypes from 'prop-types';
import { FontSize_Css_Plus } from '../../../data/common';

function Header({ config }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        width: '100%',
        height: '65px',
        borderBottom: '1px solid #CBD5E1',
        marginBottom: '20px',
      }}
    >
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {config?.orgLogoUrl !== null && config.logoAppearYN && (
          <img
            src={config?.orgLogoUrl}
            alt="Logo"
            style={{ flexShrink: 0, maxWidth: '95px', maxHeight: '38px' }}
          />
        )}
        <div
          style={{
            flexShrink: 0,
            marginRight: '10px',
            fontSize: `${config.fontSize + FontSize_Css_Plus + 2}px`,
          }}
        >
          <div
            style={{
              color: '#0AAAED',
              fontFamily: "'Pretendard', Arial, sans-serif",
              marginBottom: '2px',
              display:
                config.orgLogoUrl === null ||
                (config.orgLogoUrl !== null && !config.logoAppearYN)
                  ? 'block'
                  : 'none',
            }}
          >
            {config?.orgName}
          </div>
          <div
            style={{
              marginBottom: '2px',
              fontFamily: "'Pretendard', Arial, sans-serif",
            }}
          >
            {config?.className}
          </div>
          <div style={{ fontFamily: "'Pretendard', Arial, sans-serif" }}>
            {config?.teacherName}
          </div>
        </div>
        <div
          style={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: `${config?.fontSize + FontSize_Css_Plus + 7}px`,
            fontWeight: 700,
          }}
        >
          {config?.paperName}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexShrink: 0,
          justifyContent: 'center',
          alignItems: 'center',
          color: '#A9B6CA',
          borderRadius: '4px',
          width: '132px',
          height: '50px',
          fontSize: `${config?.fontSize}px`,
          backgroundColor: '#F0F5F9',
        }}
      >
        이름
      </div>
    </div>
  );
}

Header.propTypes = {
  config: PropTypes.object.isRequired,
};

export default React.memo(Header);
